export default __webpack_public_path__ + "static/media/news3.6a8ed775.webp";